// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-rating[data-v-05a75423]{color:rgba(233,174,26,.8784313725490196)}", ""]);
// Exports
module.exports = exports;
